!(function () {
  var t = window.GL2,
    e = window.GLV2 || {};
  if (t && e.p3) {
    var n = t.$,
      i = t.$$,
      a = t.el,
      o = t.esc,
      r = t.money,
      s = t.track;
    (window.GL3Add = function (t) {
      var e = n("form.gl-atc-container") || t,
        a = {},
        o = n(".g3-up"),
        // Required text steps built by T() (letter brownie "Personalised Message").
        q = i(".g3-tx").filter(function (t) {
          return !t.__src.value.trim();
        })[0];
      if (q)
        return (
          q.classList.add("g3-tx--need"),
          q.scrollIntoView({ behavior: "smooth", block: "center" }),
          Promise.reject({ description: "Add your message first" })
        );
      // Product Customizer steps built by D() (Customise Donuts): required choices, and a photo
      // that's still uploading to the app (its URL field is filled when the upload finishes).
      var w = i(".g3-pc").filter(function (t) {
        return t.__need && t.__need();
      })[0];
      if (w)
        return (
          w.classList.add("g3-pc--need"),
          w.scrollIntoView({ behavior: "smooth", block: "center" }),
          Promise.reject({ description: w.__msg })
        );
      // Photo groups (SL): required ones need a photo; butterfly needs photos once opted in.
      o && o.__bf && PS(o);
      var y = o
        ? i(".g3-slg", o).filter(function (t) {
            return (t.__req || (o.__bf && o.__on)) && !t.__has();
          })[0]
        : null;
      if (
        !y &&
        o &&
        !o.__bf &&
        !i(".g3-slg", o).length &&
        !i(".uploadkit-attribute-container input", o).filter(function (t) {
          return t.value;
        }).length &&
        !K().length
      )
        y = o;
      if (y)
        return (
          o.classList.add("g3-up--need"),
          y.classList.add("g3-slg--need"),
          y.scrollIntoView({ behavior: "smooth", block: "center" }),
          Promise.reject({
            description: o.__bf
              ? "Add your 4 photos, or choose No photos"
              : y.__nm && /top|bottom/.test(y.__nm)
                ? "Add your " + (/top/.test(y.__nm) ? "top" : "bottom") + " photo first"
                : "Add your photo first",
          })
        );
      // "Card" chosen and a card ticked, but the theme cleared its hidden card fields
      // (it does when its card box is toggled): refill them from the ticked card.
      var x = n('li.physical_cards_li input[name="postcard_variant"]:checked', e);
      n('.g3-seg [data-m="card"].on') &&
        x &&
        !(n('[name="properties[_postcard_variant_id]"]', e) || {}).value &&
        [
          ["_postcard_variant_id", x.value],
          ["_postcard_variant_title", x.getAttribute("variant-title")],
          ["_postcard_variant_price", x.getAttribute("variant-price")],
        ].forEach(function (t) {
          t[1] &&
            i('[name="properties[' + t[0] + ']"]', e).forEach(function (e) {
              e.value = t[1];
            });
        });
      i('[name^="properties["]', e)
        .concat(o ? i('[name^="properties["]', o) : [])
        .forEach(function (t) {
          // File inputs are never posted (the old add-to-cart serialises the form the same way;
          // Product Customizer uploads the file itself and fills a hidden _..._URL property).
          if (!t.disabled && "file" !== t.type && (("radio" !== t.type && "checkbox" !== t.type) || t.checked)) {
            var e = t.name.replace(/^properties\[(.*)\]$/, "$1");
            "" !== t.value &&
              null != t.value &&
              (a[e] =
                // several boxes ticked in one multi-select group: keep them all
                "checkbox" === t.type && t.__g3multi && a[e] ? a[e] + ", " + t.value : t.value);
          }
        });
      var r = Math.max(1, +(n('input[name="quantity"]', e) || {}).value || 1),
        s = +(n('[name="id"]', e) || {}).value,
        l = +a["_extra_variant_id:"] || 0,
        d = +a._postcard_variant_id || 0,
        c = [],
        // Butterfly boxes (old "image_cake0" path): uploaded photos add the hidden
        // "4x Uploaded Photos" $20 line, and the box line always gets _common_random_string
        // when it has photos, an upgrade or a card (same as the old template).
        b =
          "image_cake0" === (n("#updload_cake", e) || {}).value &&
          Object.keys(a).some(function (t) {
            return "_" !== t.charAt(0) && /^https?:\/\//.test(a[t]);
          });
      if (
        (l ||
          Object.keys(a).forEach(function (t) {
            /_option_name_upgrade|_extra_variant_id/.test(t) && delete a[t];
          }),
        d)
      ) {
        var p = Math.random().toString(36).slice(2, 8),
          g =
            (n(".data_time_span") || {}).value ||
            Math.floor(Date.now() / 1e3) + "_",
          u = "",
          f = {};
        i('textarea.tt-msg-input-nw:not([name^="properties["])', e).forEach(function (t) {
          t.value.trim() && (u = t.value);
        }),
          (a._common_random_string = p),
          (f[g + "Gift Message"] = u || "No Message"),
          (f._common_random_string = p),
          c.push({ id: d, quantity: 1, properties: f });
      } else
        Object.keys(a).forEach(function (t) {
          /^_postcard_/.test(t) && delete a[t];
        });
      return (
        "image_cake0" === (n("#updload_cake", e) || {}).value &&
          (b || l) &&
          !a._common_random_string &&
          (a._common_random_string = Math.random().toString(36).slice(2, 8)),
        b && c.push({ id: 39603053559870, quantity: r }),
        l && c.push({ id: l, quantity: r }),
        // came from "You might also like" on another gift: tag this add for Insights
        (function () {
          try {
            var k = JSON.parse(sessionStorage.getItem("glReco") || "null");
            k && k.h === (window.GLV2.p3 || {}).handle && Date.now() - k.t < 36e5 &&
              ((a._gl_src = "reco-similar"), (a._gl_reco = k.pos + ":" + k.list));
          } catch (t) {}
        })(),
        c.push({ id: s, quantity: r, properties: a }),
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ items: c }),
        }).then(function (t) {
          return t.json().then(function (e) {
            if (!t.ok) throw e;
            return e;
          });
        })
      );
    }),
      (window.GL3Card = function (t, e, r, l) {
        var d = function (t) {
            var e = n("img", t);
            return e
              ? String(
                  e.getAttribute("src") || e.getAttribute("data-src") || "",
                ).replace(/^\/\//, "https://")
              : "";
          },
          c = function (t) {
            return (t.textContent || "")
              .trim()
              .replace(/\s+/g, " ")
              .replace(/ Card$/i, "");
          };
        if (!t.__d) {
          if (((t.__d = !0), !n("#g3cd-font"))) {
            var p = a("link");
            (p.id = "g3cd-font"),
              (p.rel = "stylesheet"),
              (p.href =
                "https://fonts.googleapis.com/css2?family=Caveat:wght@600&display=swap"),
              document.head.appendChild(p);
          }
          (t.innerHTML =
            '<div class="g3cd"><div class="g3cd-pv"><i class="g3cd-art"></i><div class="g3cd-in"><span class="g3cd-msg"></span></div></div><div class="g3cd-hd"><span>Card: <b class="g3cd-nm">pick one below</b></span><span class="g3-mut">+$5</span></div><div class="g3cd-strip">' +
            e
              .map(function (t, e) {
                return (
                  '<button type="button" data-c="' +
                  e +
                  '" aria-label="' +
                  o(c(t)) +
                  ' card" style="background-image:url(' +
                  o(d(t)) +
                  ')"></button>'
                );
              })
              .join("") +
            "</div>" +
            (r
              ? '<label class="g3cd-lab">Your message<span class="g3-mut g3cd-n"></span></label><textarea rows="3" placeholder="Write your card message"' +
                (r.maxLength > 0 ? ' maxlength="' + r.maxLength + '"' : "") +
                ">" +
                o(r.value) +
                "</textarea>"
              : "") +
            "</div>"),
            g(n(".g3cd-strip", t)),
            i("[data-c]", t).forEach(function (t) {
              t.onclick = function () {
                var i = e[+t.getAttribute("data-c")],
                  a = n("input", i),
                  o = n("label", i);
                a ? a.click() : o && o.click(),
                  s("pdp_card_pick", { card: c(i) }),
                  l();
              };
            });
          var u = n("textarea", t),
            f = n(".g3cd-msg", t),
            h = n(".g3cd-n", t),
            v = function () {
              var t = u ? u.value.trim() : "";
              (f.textContent = t || "Your message shows up here"),
                f.classList.toggle("ph", !t),
                (f.style.fontSize =
                  t.length > 140 ? "15px" : t.length > 70 ? "18px" : ""),
                h &&
                  (h.textContent =
                    u.maxLength > 0
                      ? u.value.length + " / " + u.maxLength
                      : "");
            };
          u &&
            (u.oninput = function () {
              (r.value = u.value),
                ["input", "keyup", "change"].forEach(function (t) {
                  r.dispatchEvent(new Event(t, { bubbles: !0 }));
                }),
                v();
            }),
            v();
        }
        var b = (function () {
          var t = -1;
          return (
            e.forEach(function (e, i) {
              var a = n("input", e);
              a && a.checked && (t = i);
            }),
            t
          );
        })();
        i("[data-c]", t).forEach(function (t) {
          t.classList.toggle("on", +t.getAttribute("data-c") === b);
        }),
          (n(".g3cd-art", t).style.backgroundImage =
            b > -1 ? "url(" + d(e[b]) + ")" : ""),
          (n(".g3cd-nm", t).textContent = b > -1 ? c(e[b]) : "pick one below");
      });
    var l = [
        [
          "Literally one of the best gifts to surprise my partner with on his birthday! The surprise blast of butterflies and confetti in your loved ones face, is a moment worth paying the extra for!",
          "Daniel V.",
        ],
        [
          "My parents loved this box and couldn’t stop laughing at the confetti they were covered in.",
          "Cara H.",
        ],
        [
          "We were sufficiently entertained when my sister opened her box and got a shot of confetti in her face.",
          "Danielle F.",
        ],
        [
          "Just watching Ruby open her box was priceless when the butterflies and confetti exploded all over the place.",
          "R.S.",
        ],
        [
          "We sent our clients some cookies and opted to add the confetti bomb - we are so glad we did, they absolutely loved it!",
          "Cory W.",
        ],
        [
          "The cake explosion box with butterflies and confetti was the perfect gift for my daughter who’s very hard to surprise ❤️",
          "Sharyn T.",
        ],
        [
          "Gave this gift to my boss for his birthday and it was such a fun idea! The box exploded everywhere and the confetti was great.",
          "S.M.",
        ],
        [
          "The butterfly explosion with the confetti was fantastic! It was such a beautiful surprise for my friend’s birthday.",
          "Maryanne S.",
        ],
        [
          "Perfect for someone who is hard to buy for… as long as they don’t make you pick up all the confetti",
          "Anna S.",
        ],
        [
          "The confetti explosion was awesome and the cookies are delicious.",
          "Daniel K.",
        ],
      ],
      d = [
        [
          "My sister screamed when she opened the box, so fun surprise gets 5 stars. She loved it!",
          "Sarah B.",
        ],
        [
          "Ordered cupcakes from NZ to deliver to grandson in Hobart, Australia. High quality, perfect delivery, easiest gift ever, and the family absolutely loved it",
          "B.M.",
        ],
        [
          "Super easy to order online and super efficient. So many fantastic gift ideas for all occasions, perfect for a last minute gift idea!",
          "Rebecca M.",
        ],
        [
          "This was amazing, my friend was thoroughly surprised, and cake was bigger than expected AND delicious So impressed",
          "Diana J.",
        ],
        [
          "Fresh, delicious cupcakes and doughnuts. Delivered on time and with care. We will be using Goldelucks again!",
          "Sophie R.",
        ],
        [
          "Gave this amazing gift to my daughter-in-law for her birthday and she absolutely loved it! Quality was amazing and the treats were perfect!",
          "Wendy W.",
        ],
        [
          "Absolutely delicious, very well received by the birthday person! Super happy with the delivery updates and customer service as well, highly recommend!",
          "Caitlin A.",
        ],
        [
          "Just perfect! A delightful little box of joy brought the required response and delivered the heartfelt message I wanted to give. Highly recommend!",
          "Lisa M.",
        ],
        [
          "I ordered the Giant Tim Tam Donut Cake for my donut-loving friend’s birthday. He loved it! We all did, would definitely order again. Thank you!",
          "Charlton D.",
        ],
        [
          "The coolest thing to watch someone open! 10/10 I wish I could upload a video of my sons reaction because it was so funny!",
          "Reece A.",
        ],
      ],
      INC = /^\s*(what['\u2019]?s\s+(inside|included|in\s+the\s+box)|in\s+the\s+box)|included/i,
      HD = function (t) {
        if (/^H[1-6]$/.test(t.tagName)) return t.textContent.trim();
        if ("P" === t.tagName) {
          var b = t.querySelector("strong, b"),
            x = t.textContent.trim();
          if (b && x && x.length < 90 && b.textContent.trim() === x) return x;
          // a short line that is just "What's included / What's inside ..." counts even without bold
          if (x && x.length < 60 && INC.test(x)) return x;
        }
        return null;
      },
      // description blocks, looking inside wrapper divs (many descriptions sit in one <div>)
      FL = function (c) {
        var out = [];
        i(":scope > *", c).forEach(function (t) {
          /^(DIV|SECTION|ARTICLE)$/.test(t.tagName) && n("h1,h2,h3,h4,h5,h6,p,ul,ol", t)
            ? (out = out.concat(FL(t)))
            : out.push(t);
        });
        return out;
      },
      c = /^(a|an|the|and|or|but|of|to|in|on|at|for|by|with|per|via)$/i,
      p = function () {
        // the same rules, for checking product descriptions from the console
        window.GL3Desc = { HD: HD, INC: INC, FL: FL };
        try {
          !(function () {
            var t = n("div.g3");
            if (t && !n(".g3-low")) {
              var l = e.p3,
                d = a("div", "g3-low");
              t.appendChild(d);
              var c = n(".product-description");
              (c && c.children.length) ||
                ((c = a("div")).innerHTML = l.description || "");
              var p = { d: [], inc: [], st: [], sub: [] },
                u = "d";
              // Sections by heading: a real heading, or a paragraph that is only a short bold line.
              // "What's inside / What's included / What's in the box / In the box ..." (any apostrophe,
              // any words after) and any heading with "included" go to the yellow box.
              c &&
                FL(c).forEach(function (t) {
                  var e = HD(t);
                  if (null != e) {
                    e = e.toLowerCase();
                    u = INC.test(e)
                      ? "inc"
                      : /stor|leftover/.test(e)
                        ? "st"
                        : /substitut/.test(e)
                          ? "sub"
                          : "d";
                  }
                  p[u].push(t.outerHTML);
                });
              var f = p.inc.length
                  ? '<div class="g3-inc">' + p.inc.join("") + "</div>"
                  : "",
                h = e.product && e.product.faq;
              try {
                "string" == typeof h && (h = JSON.parse(h));
              } catch (t) {
                h = null;
              }
              var v =
                  h && h.length
                    ? h.map(function (t) {
                        return {
                          q: t.question,
                          a: "<p>" + o(t.answer) + "</p>",
                        };
                      })
                    : e.faqFallback || [],
                b = [];
              p.d.length &&
                b.push([
                  "Description",
                  '<div class="g3-rt">' + p.d.join("") + "</div>" + f,
                  !1,
                ]),
                p.inc.length && b.push(["What's included", f, !0]),
                p.st.length &&
                  b.push([
                    "Storage",
                    '<div class="g3-rt">' + p.st.join("") + "</div>",
                    !0,
                  ]),
                b.push([
                  "Delivery",
                  '<div class="g3-rt">' + DV(e.delivery) + "</div>",
                  !0,
                ]),
                v.length && b.push(["FAQ", null, !0]),
                // the description's "Product Substitution Policy" gets its own tab, last
                p.sub.length &&
                  b.push(["Substitutions", '<div class="g3-rt">' + p.sub.join("") + "</div>", !0]);
              var m = a("div", "g3-tabs");
              if (
                ((m.innerHTML =
                  '<div class="g3-tabs__bar" role="tablist">' +
                  b
                    .map(function (t, e) {
                      return (
                        '<button type="button" role="tab" class="' +
                        (e ? "" : "on") +
                        '">' +
                        t[0] +
                        "</button>"
                      );
                    })
                    .join("") +
                  "</div>" +
                  b
                    .map(function (t, e) {
                      return null == t[1]
                        ? ""
                        : '<div class="g3-panel' +
                            (t[2] ? " solo" : "") +
                            (e ? "" : " on") +
                            '" role="tabpanel">' +
                            t[1] +
                            "</div>";
                    })
                    .join("")),
                d.appendChild(m),
                window.matchMedia("(max-width: 989px)").matches)
              ) {
                var x = n(".g3-panel", m),
                  y = x && n(":scope > .g3-rt", x),
                  w = y && n(":scope > .g3-inc", x),
                  _ = y
                    ? i(
                        ":scope > h1, :scope > h2, :scope > h3, :scope > h4, :scope > h5, :scope > h6",
                        y,
                      )
                    : [];
                if (
                  (w &&
                    (w.classList.add("g3-inc--in"),
                    _[1] ? y.insertBefore(w, _[1]) : y.appendChild(w)),
                  !n("#g3inc-css"))
                ) {
                  var k = a(
                    "style",
                    "",
                    ".g3 .g3-rt .g3-inc--in{margin:14px 0 18px}.g3 .g3-inc--in h1,.g3 .g3-inc--in h2,.g3 .g3-inc--in h3,.g3 .g3-inc--in h4{display:block!important;font-size:16px!important;font-weight:700!important;margin:0 0 8px!important}",
                  );
                  (k.id = "g3inc-css"), document.head.appendChild(k);
                }
              }
              var C = null;
              v.length &&
                ((C = a(
                  "div",
                  "g3-q",
                  "<h2>Questions</h2>" +
                    v
                      .slice(0, 6)
                      .map(function (t) {
                        return (
                          '<div class="g3-qi"><button type="button" class="g3-qq" aria-expanded="false">' +
                          o(t.q) +
                          '<i>+</i></button><div class="g3-qa g3-rt">' +
                          t.a +
                          "</div></div>"
                        );
                      })
                      .join(""),
                )),
                d.appendChild(C),
                i(".g3-qq", C).forEach(function (t) {
                  t.onclick = function () {
                    var e = t.parentNode,
                      i = !e.classList.contains("on");
                    e.classList.toggle("on", i),
                      t.setAttribute("aria-expanded", i),
                      (n("i", t).innerHTML = i ? "&minus;" : "+");
                  };
                }));
              var L = i(".g3-panel", m);
              i(".g3-tabs__bar button", m).forEach(function (t, e) {
                t.onclick = function () {
                  if ((s("pdp_tab", { tab: b[e][0] }), null != b[e][1])) {
                    i(".g3-tabs__bar button", m).forEach(function (t, n) {
                      t.classList.toggle("on", e === n);
                    });
                    var t = b.slice(0, e).filter(function (t) {
                      return null != t[1];
                    }).length;
                    L.forEach(function (e, n) {
                      e.classList.toggle("on", n === t);
                    });
                  } else
                    C &&
                      C.scrollIntoView({ behavior: "smooth", block: "start" });
                };
              }),
                +e.reviewsCount &&
                  d.appendChild(
                    a(
                      "div",
                      "g3-rev",
                      '<h2>What customers say about Goldelucks</h2><div class="g3-rev__n">' +
                        o(e.reviewsRating) +
                        '</div><div class="g3-rev__s"><span class="g3-stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span><span class="g3-mut">' +
                        Number(e.reviewsCount).toLocaleString("en-AU") +
                        ' store reviews · Judge.me</span></div><div style="flex:1"></div><a class="g3-lnk" style="font-size:15px;font-weight:700" href="/pages/reviews">Read all ' +
                        Number(e.reviewsCount).toLocaleString("en-AU") +
                        "</a>",
                    ),
                  );
              // "Add to their gift": quick-add add-ons (gl-addons.js), above "You might also like"
              var P = e.product || {};
              if (window.GLA) {
                var AR = GLA.row({ surface: "pdp-addons", forId: l.id, smartFor: [l], occ: P.occasion || "" });
                d.appendChild(AR.el), g(n(".gla-row", AR.el));
              }
              var A = (P.guides || []).filter(Boolean),
                M = {};
              A = A.filter(function (t) {
                return !M[t.u] && ((M[t.u] = 1), !0);
              }).slice(0, 3);
              var E = a(
                "div",
                "g3-two",
                '<div class="g3-box g3-rr"><h2>You might also like</h2><div class="g3-tiles"></div></div>' +
                  (A.length
                    ? '<div class="g3-gd"><h2>' +
                      o(P.guidesHead || "Gift guides") +
                      "</h2>" +
                      A.map(function (t) {
                        return (
                          '<a href="' +
                          o(t.u) +
                          '"><span class="g3-tag">' +
                          o(t.tag) +
                          "</span><span>" +
                          o(t.t) +
                          "</span><span>&#8250;</span></a>"
                        );
                      }).join("") +
                      "</div>"
                    : ""),
              );
              A.length || (E.style.gridTemplateColumns = "1fr"), d.appendChild(E);
              // Tiles: {id, h, t, u, i, p (cents), v (price varies), r (stars), n (reviews)}.
              // The theme's own list (similar price, gl-v2.liquid) shows first, as list "t.<product id>".
              // Theme setting "Learning recommendations" on: ask Insights for its list
              // (GET /apps/insights/reco?product=&b=) and swap only if it answers within 800 ms with 3+ handles.
              // list_id goes back unchanged in gl_reco_view, gl_reco_click and _gl_reco (Insights contract).
              var tl = n(".g3-tiles", E),
                pub = (window.GLA && GLA.pub) || function () {},
                cur = { list: (P.similar || []).slice(0, 8), lid: "t." + l.id },
                ready = !P.learnReco,
                inView = !1,
                sent = !1,
                view = function () {
                  !sent &&
                    ready &&
                    inView &&
                    cur.list.length &&
                    ((sent = !0),
                    pub("gl_reco_view", {
                      source_product_id: l.id,
                      shown_product_ids: cur.list.slice(0, 12).map(function (t) {
                        return t.id;
                      }),
                      list_id: cur.lid,
                    }));
                },
                draw = function (list, lid) {
                  cur = { list: list, lid: lid };
                  if (!list.length) return void (n(".g3-box", E).style.display = "none");
                  n(".g3-box", E).style.display = "";
                  tl.innerHTML = list
                    .map(function (t, i) {
                      return (
                        '<a class="g3-tile" href="' +
                        o(t.u) +
                        '" data-i="' +
                        i +
                        '"><div>' +
                        (t.i ? '<img loading="lazy" src="' + o(t.i) + '" alt="">' : "") +
                        "</div><p>" +
                        o(t.t) +
                        "</p>" +
                        (+t.n > 0 && t.r
                          ? '<span class="g3-tst" aria-label="Rated ' +
                            o((+t.r).toFixed(1)) +
                            " out of 5 from " +
                            o(t.n) +
                            ' reviews"><span class="g3-tst-s" aria-hidden="true">&#9733;</span> ' +
                            o((+t.r).toFixed(1)) +
                            ' <span class="g3-mut">(' +
                            o(t.n) +
                            ")</span></span>"
                          : "") +
                        // plain lowest price, no "From" (Phillip)
                        "<b>" +
                        r(t.p) +
                        "</b></a>"
                      );
                    })
                    .join("");
                  g(tl);
                  tl.scrollLeft = 0;
                  tl.dispatchEvent(new Event("scroll"));
                },
                settle = function () {
                  ready || ((ready = !0), view());
                };
              draw(cur.list, cur.lid);
              "IntersectionObserver" in window
                ? new IntersectionObserver(
                    function (es, io) {
                      es.some(function (x) {
                        return x.isIntersecting;
                      }) && ((inView = !0), io.disconnect(), view());
                    },
                    { threshold: 0.4 },
                  ).observe(tl)
                : ((inView = !0), view());
              tl.addEventListener("click", function (ev) {
                var t = ev.target.closest(".g3-tile");
                if (!t) return;
                var i = +t.getAttribute("data-i"),
                  x = cur.list[i];
                if (!x) return;
                // the tile loads its gift: queued and sent on that page (GLA.pubNav)
                (window.GLA && GLA.pubNav ? GLA.pubNav : pub)("gl_reco_click", { source_product_id: l.id, product_id: x.id, position: i + 1, list_id: cur.lid });
                // the next add of that gift carries _gl_src / _gl_reco (GL3Add)
                try {
                  sessionStorage.setItem("glReco", JSON.stringify({ h: x.h, pos: i + 1, list: cur.lid, t: Date.now() }));
                } catch (e) {}
              });
              if (P.learnReco) {
                // bucket 0-9, once per visitor (session)
                var bk = String(Math.floor(10 * Math.random()));
                try {
                  var sb = sessionStorage.getItem("glRecoB");
                  /^\d$/.test(sb || "") ? (bk = sb) : sessionStorage.setItem("glRecoB", bk);
                } catch (e) {}
                var late = !1,
                  wait = setTimeout(function () {
                    (late = !0), settle();
                  }, 800),
                  known = {};
                (P.similar || []).forEach(function (t) {
                  known[t.h] = t;
                });
                fetch("/apps/insights/reco?product=" + encodeURIComponent(l.handle) + "&b=" + bk, { credentials: "same-origin" })
                  .then(function (t) {
                    return t.ok ? t.json() : null;
                  })
                  .then(function (j) {
                    var hs = ((j && j.handles) || []).filter(function (h) {
                      return h && h !== l.handle;
                    }).slice(0, 8);
                    if (late || hs.length < 3 || !j.list_id) return settle();
                    clearTimeout(wait);
                    // tile data: from the theme list when it has the gift, else the product's .js (1.2 s cap)
                    var cap = setTimeout(settle, 1200);
                    return Promise.all(
                      hs.map(function (h) {
                        return known[h]
                          ? known[h]
                          : fetch("/products/" + encodeURIComponent(h) + ".js")
                              .then(function (t) {
                                return t.ok ? t.json() : null;
                              })
                              .then(function (p) {
                                return p && p.available
                                  ? { id: p.id, h: p.handle, t: p.title, u: p.url, i: p.featured_image ? String(p.featured_image).replace(/^\/\//, "https://") + (p.featured_image.indexOf("?") > -1 ? "&" : "?") + "width=400" : "", p: p.price, v: p.price_varies }
                                  : null;
                              })
                              .catch(function () {
                                return null;
                              });
                      }),
                    ).then(function (ps) {
                      clearTimeout(cap);
                      ps = ps.filter(Boolean);
                      !ready && ps.length >= 3 && draw(ps, String(j.list_id));
                      settle();
                    });
                  })
                  .catch(settle);
              }
            }
          })(),
            T(),
            D(),
            (function () {
              var t = n("form.gl-atc-container"),
                e = n(".g3-buy");
              if (t && e && !n(".g3-up")) {
                var o = i(".uploadkit", t).filter(function (t) {
                  // UploadKit also injects an empty box into every form; skip it unless it has an uploader
                  return (
                    !t.closest("#postCardStep") &&
                    !(t.classList.contains("uploadkit-injected") && !n(".uploadkit-uploader", t))
                  );
                })[0];
                if (o) {
                  var r = o.closest(".tt-collapse-content") || o.parentNode,
                    // Butterfly boxes: the photos are optional and cost $20 (old "image_cake0" step).
                    bf = "image_cake0" === (n("#updload_cake", t) || {}).value,
                    // burn cakes: Top + Bottom photos
                    bu = !!n(".burn-cake-uploadkit", t),
                    fs = !!o.closest("#firstStep");
                  // never move the product form itself
                  r.contains(t) && (r = o);
                  if (!n("#g3up-css")) {
                    var s = a(
                      "style",
                      "",
                      ".g3-up .tt-collapse-content,.g3-up .tt-uploadkit-content{display:block!important;height:auto!important;opacity:1!important;visibility:visible!important;padding:0!important;border:0!important}.g3-up .disabled,.g3-up [disabled]{pointer-events:auto;opacity:1}.g3-up .gl-upload-box{margin:0!important}.g3-up .burn-cake-uploadkit .uploadkit-uploader{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:8px 0}.g3-up--need .g3-sh h2{color:#C4264F!important}.g3-up--need .g3-upn{display:block}.g3-upn{display:none;color:#C4264F;font-size:13.5px;font-weight:600}.g3-up--first .uploadkit-uploader:not(:first-child){display:none!important}.g3-upo{margin:0 0 10px;font-size:13.5px;color:#6B625C}",
                    );
                    (s.id = "g3up-css"), document.head.appendChild(s);
                  }
                  var l = a(
                    "div",
                    // butterfly: hide the postcard uploader that shares the box (burn cakes need both of theirs)
                    "g3-step g3-up" + (bf && fs ? " g3-up--first" : ""),
                    // headings agreed with Phillip (27 Oct): one heading + one line, per template
                    '<div class="g3-sh"><span class="g3-num"></span><h2>' +
                      (bf || bu ? "Upload Photos" : "Upload Photo/Logo") +
                      '</h2></div><p class="g3-upo">' +
                      (bf ? "Add 4 photos." : bu ? "The top photo burns away to reveal the bottom photo." : "Add 1 to 3 photos or logos.") +
                      '</p><div class="g3-upn">Add your photo to continue</div>',
                  );
                  bf && l.setAttribute("data-optional", ""), l.appendChild(r);
                  var d = i(":scope > .g3-step, :scope > .g3-x2", e),
                    c = d[0],
                    // butterfly: options, then Make It Explode, then photos; others: right after the options
                    p =
                      (bf && n(":scope > .g3-x2", e)) ||
                      d
                        .filter(function (t) {
                          return n(".g3-sizes, .g3-chips, .g3-sws", t);
                        })
                        .pop();
                  p
                    ? e.insertBefore(l, p.nextSibling)
                    : c
                      ? e.insertBefore(l, c)
                      : e.appendChild(l),
                    i(".g3-num", e).forEach(function (t, e) {
                      t.textContent = e + 1;
                    });
                  // Photo slots: one row per UploadKit uploader (see SL below). UploadKit can render
                  // after this step is built, so groups are (re)built whenever it does.
                  (l.__bf = bf),
                    bf && PO(l),
                    SLB(l),
                    window.MutationObserver &&
                      new MutationObserver(function () {
                        SLB(l), window.GL3 && GL3.sync && GL3.sync();
                      }).observe(l, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["value", "src"] });
                }
              }
            })(),
            (t = n(".g3-buy")) &&
              (i(".g3-x2", t).forEach(function (t) {
                n(".g3-xo", t) || t.remove();
              }),
              i(".g3-num", t).forEach(function (t, e) {
                t.textContent = e + 1;
              })),
            h(),
            setTimeout(h, 1500),
            (function () {
              var t = n(".g3-xr");
              if (t && !t.__r) {
                t.__r = !0;
                var e = t.innerHTML;
                t.classList.add("g3-xrr"),
                  (t.innerHTML =
                    '<span class="g3-stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span>'),
                  t.appendChild(u(t, l)),
                  t.appendChild(a("div", "g3-xm", e));
              }
            })(),
            // "What customers say": review cards, the highlights only. This product's 4-5 star Judge.me
            // reviews (already in the page's own review widget, no extra requests): 5 stars first, reviews
            // with real text first, newest first. Fewer than 2 → the store's 5-star picks, headed "From our
            // customers". Up to 6. The summary and "Read all" link above still lead to every review.
            (function () {
              var t = n(".g3-rev");
              if (!t || t.__r) return;
              t.__r = !0;
              var box = a("div", "g3-rvc");
              t.appendChild(box);
              var st = function (k) {
                  k = Math.max(0, Math.min(5, Math.round(+k || 5)));
                  return (
                    '<span class="g3-rvc__st" aria-label="Rated ' + k + ' out of 5">' +
                    Array(k + 1).join("&#9733;") +
                    '<span class="g3-rvc__off">' + Array(6 - k).join("&#9733;") + "</span></span>"
                  );
                },
                draw = function () {
                  var seen = {},
                    pr = i(".jdgm-rev")
                      .map(function (r) {
                        var b = n(".jdgm-rev__body", r),
                          sc = n(".jdgm-rev__rating", r);
                        return {
                          name: ((n(".jdgm-rev__author", r) || {}).textContent || "").trim(),
                          score: sc ? sc.getAttribute("data-score") : 5,
                          // Judge.me adds its own "Read more" / "Read less" links inside the body
                          body: ((b || {}).textContent || "").replace(/\s*Read (more|less)\s*/gi, " ").replace(/\s+/g, " ").trim(),
                          ok: !!n(".jdgm-rev__buyer-badge", r),
                          t: Date.parse(((n(".jdgm-rev__timestamp", r) || { getAttribute: function () {} }).getAttribute("data-content") || "").replace(" UTC", "Z").replace(" ", "T")) || 0,
                        };
                      })
                      .filter(function (x) {
                        var k = x.name + "|" + x.body;
                        return x.body && !seen[k] && (seen[k] = 1);
                      }),
                    // a body that's only the product name (or a few words) isn't much of a review
                    ttl = (n("h1") || {}).textContent || "",
                    txt = function (x) {
                      return x.body.length >= 25 && x.body.toLowerCase() !== ttl.trim().toLowerCase() ? 1 : 0;
                    },
                    good = pr
                      .filter(function (x) {
                        return +x.score >= 4;
                      })
                      .sort(function (a, b) {
                        return b.score - a.score || txt(b) - txt(a) || b.t - a.t;
                      }),
                    own = good.length >= 2,
                    list = own
                      ? good.slice(0, 6)
                      : d.slice(0, 6).map(function (q) {
                          return { name: q[1], score: 5, body: q[0] };
                        });
                  box.__pr = pr.length;
                  box.innerHTML =
                    "<h3>" + (own ? "Reviews for this gift" : "From our customers") + '</h3><div class="g3-rvc__row">' +
                    list
                      .map(function (x) {
                        return (
                          '<figure class="g3-rvc__c">' + st(x.score) + "<blockquote>" + o(x.body) + "</blockquote><figcaption>" +
                          o(x.name || "Goldelucks customer") +
                          (x.ok ? ' <span class="g3-mut">· Verified buyer</span>' : "") +
                          "</figcaption></figure>"
                        );
                      })
                      .join("") +
                    "</div>";
                };
              draw();
              // the review widget can fill in after us: redraw once it has
              [1500, 4000].forEach(function (ms) {
                setTimeout(function () {
                  box.__pr || draw();
                }, ms);
              });
            })();
        } catch (t) {
          window.console && console.warn("gl-v3-low", t);
        }
        var t;
      };
    document.addEventListener("gl3:ready", p), window.GL3 && p();
  }
  // UploadKit stores photos as ".../download.html?...&uu=<uploadcare id>" links; show them via the Uploadcare CDN.
  function TH(t) {
    var e = String(t).match(/uploadkit\.app\/.*[?&]uu=([0-9a-f-]{36})/i);
    return e ? "https://ucarecdn.com/" + e[1] + "/-/preview/300x300/" : t;
  }
  // Letter brownies ("Customise Brownie"): the old form's required "Personalised Message" box
  // gets its own step after the options. Rules are enforced in the box: letters, numbers and
  // spaces only, 8 per row (rows wrap on their own, at a space where possible), 3 rows.
  // Rows are joined with a line break, as in the old template. The old textarea stays the one
  // that is posted.
  function BF(t) {
    // letters are cut as capitals (Phillip, 27 Oct): the box, the preview and the saved value are uppercase
    var e = String(t || "").replace(/\r/g, "").toUpperCase(),
      n = e.replace(/[^A-Z0-9 \n]/g, "").replace(/ {2,}/g, " "),
      i = [];
    var a = n.split("\n");
    a.forEach(function (t, n) {
      for (var r = !1; t.length > 8; ) {
        var e = t.lastIndexOf(" ", 8);
        e <= 0 && (e = 8), i.push(t.slice(0, e)), (t = t.slice(e).replace(/^ /, "")), (r = !0);
      }
      // a wrap never leaves an empty row behind (unless you're typing on it now)
      (t || !r || n === a.length - 1) && i.push(t);
    });
    return { v: i.slice(0, 3).join("\n"), strip: n !== e, cut: i.length > 3 };
  }
  // Brownie preview: a top-down chocolate slab with sprinkles in this product's colours and the
  // message as centred rows of white fondant capitals (as the real letters are placed).
  function BV(t, ph) {
    var e = ((window.GLV2 || {}).p3 || {}).title || "",
      n = /pink/i.test(e) && /red/i.test(e)
        ? ["#F7A8C4", "#C8102E", "#F06C9B", "#FFFFFF"]
        : /pink/i.test(e)
        ? ["#F7A8C4", "#F06C9B", "#FFF6EE", "#FFFFFF"]
        : /blue/i.test(e)
          ? ["#7EC8F2", "#2F7FD1", "#FFF6EE", "#FFFFFF"]
          : /rainbow/i.test(e)
            ? ["#F25C54", "#F7B32B", "#5CC48A", "#4A90E2", "#B07CE8", "#FFFFFF"]
            : /christmas/i.test(e)
              ? ["#C8102E", "#1E7B3C", "#F4E3B0", "#FFFFFF"]
              : ["#D9B154", "#B8892F", "#F4E3B0", "#FFFFFF"],
      i = "",
      a = 7;
    // fixed pseudo-random sprinkles, so the slab doesn't change while typing
    for (var r = 0; r < 170; r++) {
      a = (9301 * a + 49297) % 233280;
      var s = 14 + (a / 233280) * 272;
      a = (9301 * a + 49297) % 233280;
      var l = 14 + (a / 233280) * 272;
      a = (9301 * a + 49297) % 233280;
      // photo brownies: no sprinkles on the printed photo
      if (ph && s > 62 && s < 238 && l > 62 && l < 238) continue;
      i +=
        '<circle cx="' + s.toFixed(1) + '" cy="' + l.toFixed(1) + '" r="' + (1.6 + (a / 233280) * 2.6).toFixed(1) + '" fill="' + n[r % n.length] + '"/>';
    }
    if (ph)
      // photo brownies: the photo is printed as a square in the middle of the slab
      return (
        '<svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="g3bg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#5A3220"/><stop offset="1" stop-color="#3B1F13"/></linearGradient><clipPath id="g3pc"><rect x="72" y="72" width="156" height="156" rx="10"/></clipPath></defs><rect x="4" y="4" width="292" height="292" rx="18" fill="url(#g3bg)"/>' +
        i +
        ("-" === ph
          ? '<rect x="72" y="72" width="156" height="156" rx="10" fill="#FFFDF8" opacity=".35"/><text x="150" y="158" text-anchor="middle" font-family="\'League Spartan\',Arial,sans-serif" font-weight="800" font-size="24" fill="#3B1F13" opacity=".7">YOUR PHOTO</text>'
          : '<rect x="68" y="68" width="164" height="164" rx="12" fill="#FFFDF8"/><image href="' + o(ph) + '" x="72" y="72" width="156" height="156" preserveAspectRatio="xMidYMid slice" clip-path="url(#g3pc)"/>') +
        "</svg>"
      );
    var c = String(t || "")
        .split("\n")
        .map(function (t) {
          return t.trim();
        })
        .filter(Boolean),
      // empty box: a faded placeholder, like the product photo
      f = !c.length && (c = ["YOUR", "MESSAGE"]),
      d = c.reduce(function (t, e) {
        return Math.max(t, e.length);
      }, 1),
      p = Math.min(54, 252 / (0.66 * d)),
      u = 1.12 * p,
      g = 150 - ((c.length - 1) * u) / 2 + 0.36 * p;
    return (
      '<svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="g3bg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#5A3220"/><stop offset="1" stop-color="#3B1F13"/></linearGradient><filter id="g3bs" x="-10%" y="-10%" width="120%" height="130%"><feDropShadow dx="0" dy="2" stdDeviation="1.6" flood-color="#000" flood-opacity=".45"/></filter></defs><rect x="4" y="4" width="292" height="292" rx="18" fill="url(#g3bg)"/>' +
      i +
      '<g fill="#FFFDF8" stroke="#E6DBCD" stroke-width="1" font-family="\'League Spartan\',Arial,sans-serif" font-weight="800" letter-spacing="1" filter="url(#g3bs)"' + (f ? ' opacity=".35"' : "") + ">" +
      c
        .map(function (t, e) {
          return '<text x="150" y="' + (g + e * u).toFixed(1) + '" text-anchor="middle" font-size="' + p.toFixed(1) + '">' + o(t) + "</text>";
        })
        .join("") +
      "</g></svg>"
    );
  }
  // fallback: centred rows of letter tiles, no blank squares
  function BT(t) {
    return (
      '<div class="g3-txt">' +
      String(t || "")
        .split("\n")
        .map(function (t) {
          return (
            "<span>" +
            t
              .trim()
              .split("")
              .map(function (t) {
                return " " === t ? '<i style="background:none;box-shadow:none"></i>' : "<i>" + o(t) + "</i>";
              })
              .join("") +
            "</span>"
          );
        })
        .join("") +
      "</div>"
    );
  }
  // what's saved and counted: each row trimmed, no empty rows at the end (the box keeps the
  // space you just typed so you can carry on to the next word)
  function TR(t) {
    return String(t || "")
      .split("\n")
      .map(function (t) {
        return t.trim();
      })
      .join("\n")
      .replace(/\n+$/, "");
  }
  function T() {
    var t = n("form.gl-atc-container"),
      e = n(".g3-buy"),
      r = t && n('textarea[name="properties[Personalised Message]"]', t);
    if (r && e && !n(".g3-tx")) {
      if (!n("#g3tx-css")) {
        var s = a(
          "style",
          "",
          ".g3-tx textarea{width:100%;min-height:104px;border:1.5px solid #CFC6BE;border-radius:12px;padding:10px 12px;font:600 20px/1.35 'League Spartan',sans-serif;letter-spacing:.04em;resize:none;background:#fff;color:#1F1A17}.g3-tx textarea:focus{outline:0;border-color:#1F1A17}.g3-txh{display:flex;justify-content:space-between;gap:12px;margin:0 0 8px;font-size:13.5px;color:#6B625C}.g3-txn{white-space:nowrap}.g3-txw{display:none;margin-top:6px;color:#C4264F;font-size:13.5px;font-weight:600}.g3-tx--need textarea{border-color:#C4264F}.g3-tx--need .g3-sh h2{color:#C4264F!important}.g3-tx--need .g3-txw{display:block}.g3-txo{margin-top:6px;font-size:13.5px;font-weight:600;color:#8A5A00}.g3-tx textarea{text-transform:uppercase}.g3-txv{margin:12px 0 0;max-width:300px}.g3-txv svg{display:block;width:100%;height:auto;border-radius:14px}.g3-txt{display:flex;flex-direction:column;align-items:center;gap:4px}.g3-txt span{display:flex;gap:4px}.g3-txt i{width:28px;height:28px;border-radius:6px;background:#fff;box-shadow:inset 0 0 0 1.5px #1F1A17;display:flex;align-items:center;justify-content:center;font:700 15px/1 'League Spartan',sans-serif;font-style:normal;color:#1F1A17}",
        );
        (s.id = "g3tx-css"), document.head.appendChild(s);
      }
      var d = a(
          "div",
          "g3-step g3-tx",
          '<div class="g3-sh"><span class="g3-num"></span><h2>Customise Brownie</h2></div><div class="g3-txh"><span>Capital letters and numbers, up to 8 per row, 3 rows.</span><span class="g3-txn"></span></div><textarea rows="3" aria-label="Your brownie message" autocomplete="off" autocapitalize="characters" spellcheck="false"></textarea><div class="g3-txo" hidden></div><div class="g3-txv" aria-hidden="true"></div><div class="g3-txw">Add your message to continue</div>',
        ),
        c = n("textarea", d),
        o0 = n(".g3-txo", d),
        p = function () {
          n(".g3-txn", d).textContent = TR(c.value).replace(/\n/g, "").length + " / 24";
          var t = n(".g3-txv", d);
          try {
            t.innerHTML = BV(c.value);
          } catch (e) {
            t.innerHTML = BT(c.value);
          }
        },
        u = function (t, e) {
          // fit the box to the rules; keep the caret where the shopper is typing
          var t0 = t.value,
            n = BF(t.value),
            a = null == e ? n.v.length : BF(t.value.slice(0, e)).v.length;
          return (
            n.v !== t.value && ((t.value = n.v), t.setSelectionRange && t.setSelectionRange(a, a)),
            (n.strip || n.cut) &&
              N0(
                // name the words that didn't fit (a paste or autocorrect), so nothing goes missing silently;
                // one more letter typed into a full box just gets the limit
                (n.strip ? "Letters and numbers only. " : "") +
                  (n.cut ? (WF(t0, n.v).length > 1 ? "Won't fit: " + WF(t0, n.v) + " (3 rows of 8)" : "That's the limit: 3 rows of 8") : ""),
              ),
            n
          );
        },
        // the words typed that aren't in the box after fitting it (from the first one that differs)
        WF = function (o, k) {
          var w = function (x) {
              return String(x).toUpperCase().replace(/[^A-Z0-9\s]/g, "").split(/\s+/).filter(Boolean);
            },
            a = w(o),
            b = w(k),
            j = 0;
          for (; j < a.length && a[j] === b[j]; ) j++;
          return a.slice(j).join(" ");
        },
        // the note stays up for a few seconds, then goes
        N0 = function (t) {
          (o0.textContent = t),
            (o0.hidden = !1),
            clearTimeout(N0.t),
            (N0.t = setTimeout(function () {
              o0.hidden = !0;
            }, /^Won't fit/.test(t) || / Won't fit/.test(t) ? 7e3 : 4e3));
        },
        w = function () {
          (r.value = TR(c.value)),
            ["input", "keyup", "change"].forEach(function (t) {
              r.dispatchEvent(new Event(t, { bubbles: !0 }));
            });
        };
      r.removeAttribute("maxlength"), (d.__src = r), (c.value = BF(r.value).v), TR(c.value) !== r.value && w();
      (c.oninput = function () {
        u(c, c.selectionStart), w(), c.value.trim() && d.classList.remove("g3-tx--need"), p();
      }),
        // a 4th row can't be started
        c.addEventListener("keydown", function (t) {
          "Enter" === t.key && c.value.split("\n").length >= 3 && (t.preventDefault(), N0("That's the limit: 3 rows of 8"));
        }),
        // the old textarea can be filled by edit-from-cart
        ["input", "change"].forEach(function (t) {
          r.addEventListener(t, function () {
            r.value !== TR(c.value) && ((c.value = BF(r.value).v), TR(c.value) !== r.value && w(), p());
          });
        }),
        p();
      var g = i(":scope > .g3-step, :scope > .g3-x2", e),
        h = g
          .filter(function (t) {
            return n(".g3-sizes, .g3-chips, .g3-sws", t);
          })
          .pop();
      h ? e.insertBefore(d, h.nextSibling) : g[0] ? e.insertBefore(d, g[0]) : e.appendChild(d),
        i(".g3-num", e).forEach(function (t, e) {
          t.textContent = e + 1;
        });
    }
  }
  // Customise Donuts: the Product Customizer options in the old form (icing select, sprinkle
  // swatches, photo/logo file) become gl-v3 steps after the sizes. They set the app's own
  // inputs, so the posted properties are what the old page posts. The app re-renders its
  // options after load and on every size change, so inputs are looked up live each time and
  // the shopper's choices are put back after a re-render.
  function D() {
    var t = n("form.gl-atc-container"),
      e = n(".g3-buy"),
      o = t ? i(".product-customizer-option", t) : [];
    if (o.length && e && !n(".g3-pc")) {
      if (!n("#g3pc-css")) {
        var r = a(
          "style",
          "",
          ".g3-pcs{display:flex;flex-wrap:wrap;gap:10px}.g3-pcb{display:flex;align-items:center;gap:8px;min-height:44px;padding:6px 14px 6px 6px;border:1.5px solid #E6DED6;border-radius:999px!important;background:#fff!important;color:#1F1A17!important;font:inherit;font-size:14px;line-height:1.2;text-transform:none!important;letter-spacing:0!important;cursor:pointer}.g3-pcb i{width:30px;height:30px;flex:none;border-radius:50%;background:#eee center/cover;box-shadow:inset 0 0 0 1px rgba(0,0,0,.12)}.g3-pcb.on{border-color:#1F1A17;box-shadow:inset 0 0 0 1px #1F1A17}.g3-pcup{padding:6px 16px}.g3-pcw{display:none;margin-top:8px;color:#C4264F;font-size:13.5px;font-weight:600}.g3-pc--need .g3-pcw{display:block}.g3-pc--need .g3-sh h2{color:#C4264F!important}.g3-pcf{display:flex;align-items:center;gap:12px;flex-wrap:wrap}.g3-pcf img{width:64px;height:64px;border-radius:10px;object-fit:cover}.g3-pcf .g3-mut{font-size:13.5px}",
        );
        (r.id = "g3pc-css"), document.head.appendChild(r);
      }
      var l = [],
        d = function () {
          l.forEach(function (t) {
            t();
          });
        },
        ch = function (t) {
          t.dispatchEvent(new Event("change", { bubbles: !0 }));
        };
      o.forEach(function (o) {
        var r = (n("label", o) || {}).textContent || "",
          c = o.classList.contains("option-required"),
          nm = o.getAttribute("data-option-name"),
          L = function () {
            return (
              n('.product-customizer-option[data-option-name="' + nm + '"]', n("form.gl-atc-container") || t) || o
            );
          },
          P = function () {
            return n("select", L());
          },
          U = function () {
            return i('input[type="checkbox"], input[type="radio"]', L());
          },
          G = function () {
            return n('input[type="file"]', L());
          },
          f = a("div", "g3-step g3-pc"),
          h = "",
          v = null,
          st = null;
        if (P()) {
          // icing: select + the app's colour swatches
          var m = {};
          i(".product-customizer-swatch", o).forEach(function (t) {
            var e = n("span[style]", t);
            m[t.getAttribute("data-value")] = e ? e.style.background : "";
          }),
            (h =
              '<div class="g3-pcs">' +
              i("option", P())
                .filter(function (t) {
                  return t.value;
                })
                .map(function (t) {
                  return (
                    '<button type="button" class="g3-pcb" data-v="' +
                    s0(t.value) +
                    '"><i style="background:' +
                    s0(m[t.value] || "#eee") +
                    '"></i>' +
                    s0(t.value) +
                    "</button>"
                  );
                })
                .join("") +
              "</div>"),
            (v = function () {
              var t = P();
              t && st && !t.value && ((t.value = st), ch(t));
              i(".g3-pcb", f).forEach(function (e) {
                e.classList.toggle("on", !!t && e.getAttribute("data-v") === t.value);
              });
            }),
            (f.__need = function () {
              return c && !(P() || {}).value;
            });
        } else if (U().length) {
          // sprinkles: the app's image swatches; single or multi-select as the app is set up
          var y =
              "1" === (n("ul[data-multiple_selection]", o) || { getAttribute: function () {} }).getAttribute("data-multiple_selection"),
            W = U().map(function (t) {
              var e = n("img", t.closest("li") || o);
              return { v: t.value, img: e ? e.getAttribute("src") : "" };
            });
          (st = []),
            (h =
              '<div class="g3-pcs">' +
              W.map(function (t) {
                return (
                  '<button type="button" class="g3-pcb" data-c="' +
                  s0(t.v) +
                  '"><i style="background-image:url(' +
                  s0(t.img) +
                  ')"></i>' +
                  s0(t.v) +
                  "</button>"
                );
              }).join("") +
              "</div>"),
            (v = function () {
              var t = U(),
                e = t.filter(function (t) {
                  return t.checked;
                });
              t.forEach(function (t) {
                t.__g3multi = y;
              }),
                !e.length &&
                  st.length &&
                  t.forEach(function (t) {
                    st.indexOf(t.value) > -1 && !t.checked && ((t.checked = !0), ch(t));
                  }),
                i(".g3-pcb", f).forEach(function (e) {
                  var n = t.filter(function (t) {
                    return t.value === e.getAttribute("data-c");
                  })[0];
                  e.classList.toggle("on", !!n && n.checked);
                });
            }),
            (f.__need = function () {
              return (
                c &&
                !U().some(function (t) {
                  return t.checked;
                })
              );
            });
        } else if (G()) {
          // photo/logo: the app uploads the file and fills a hidden _..._URL field
          (r = "Add Your Photo or Logo (Optional)"),
            (h =
              '<div class="g3-pcf"><button type="button" class="g3-pcb g3-pcup">Choose a photo</button><span class="g3-mut g3-pcst"></span></div>'),
            (v = function () {
              var t = L(),
                e = n("input.public_url", t),
                a = G(),
                r = n(".g3-pcf", f),
                o = n("img", r);
              // remember the uploaded URL; put it back if a re-render dropped it
              e && e.value && (st = { n: e.name, v: e.value }),
                !(e && e.value) &&
                  st &&
                  !n("input.g3-pcurl", t) &&
                  ((e = document.createElement("input")),
                  (e.type = "hidden"),
                  (e.className = "public_url g3-pcurl"),
                  (e.name = st.n),
                  (e.value = st.v),
                  t.appendChild(e));
              var c =
                (e && e.value) ||
                ((n('.g3e-keep input[name$="_URL]"]') || {}).value || "");
              /\.(jpe?g|png|gif|webp)(\?|$)/i.test(c)
                ? (o || ((o = document.createElement("img")), (o.alt = ""), r.insertBefore(o, r.firstChild)),
                  o.getAttribute("src") !== c && (o.src = c),
                  // this step shows the photo itself; drop edit's generic "Current photos" row
                  (n(".g3e-ph") || { remove: function () {} }).remove())
                : o && o.remove(),
                (n(".g3-pcup", f).textContent = c ? "Change photo" : "Choose a photo"),
                (n(".g3-pcst", f).textContent =
                  a && a.files && a.files.length && !(e && e.value)
                    ? "Uploading..."
                    : c
                      ? "Photo added"
                      : "");
            }),
            (f.__need = function () {
              var t = G(),
                e = n("input.public_url", L());
              return !!(t && t.files && t.files.length && !(e && e.value));
            }),
            (f.__msg = "Your photo's still uploading. Try again in a moment.");
        }
        if (h) {
          (f.innerHTML =
            '<div class="g3-sh"><span class="g3-num"></span><h2>' +
            s0(r) +
            "</h2></div>" +
            h +
            '<div class="g3-pcw">Choose one to continue</div>'),
            (f.__msg = f.__msg || "Choose your " + r.toLowerCase() + " first"),
            i(".g3-pcb[data-v]", f).forEach(function (t) {
              t.onclick = function () {
                var e = P();
                (st = t.getAttribute("data-v")),
                  e && ((e.value = st), ch(e)),
                  i(".product-customizer-swatch", L()).forEach(function (t) {
                    t.classList.toggle("selected", t.getAttribute("data-value") === st);
                  });
                var a = n(".product-customizer-selected-swatch", L());
                a && (a.textContent = st),
                  f.classList.remove("g3-pc--need"),
                  s("pdp_option", { value: st }),
                  d(),
                  // a choice clears "Choose your ... first" on the Add to cart button
                  window.GL3 && GL3.sync && GL3.sync();
              };
            }),
            i(".g3-pcb[data-c]", f).forEach(function (t) {
              t.onclick = function () {
                var e = t.getAttribute("data-c"),
                  a = U(),
                  r = a.filter(function (t) {
                    return t.value === e;
                  })[0];
                if (r) {
                  var o = !r.checked || !y;
                  // save the new choice first: the change events below re-run d()
                  (st = a
                    .filter(function (t) {
                      return t === r ? o : y && t.checked;
                    })
                    .map(function (t) {
                      return t.value;
                    })),
                    y ||
                      a.forEach(function (t) {
                        t !== r && t.checked && ((t.checked = !1), ch(t));
                      }),
                    r.checked !== o && ((r.checked = o), ch(r)),
                    f.classList.remove("g3-pc--need"),
                    s("pdp_option", { value: e }),
                    d(),
                  // a choice clears "Choose your ... first" on the Add to cart button
                  window.GL3 && GL3.sync && GL3.sync();
                }
              };
            });
          var b = n(".g3-pcup", f);
          b &&
            ((b.onclick = function () {
              var t = G();
              t &&
                (t.__g3 ||
                  ((t.__g3 = 1),
                  t.addEventListener("change", function () {
                    // a new photo replaces the one kept from the cart line or chosen before
                    (st = null),
                      i('.g3e-keep input[name$="_URL]"], input.g3-pcurl').forEach(function (t) {
                        t.remove();
                      });
                    var e = n(".g3e-ph");
                    e && e.remove(), d();
                  })),
                s("pdp_upload_slot"),
                t.click());
            })),
            l.push(v);
          var x = i(":scope > .g3-step, :scope > .g3-x2", e),
            k =
              i(".g3-pc", e).pop() ||
              x
                .filter(function (t) {
                  return n(".g3-sizes, .g3-chips, .g3-sws", t);
                })
                .pop();
          k ? e.insertBefore(f, k.nextSibling) : x[0] ? e.insertBefore(f, x[0]) : e.appendChild(f);
        }
      }),
        // the app re-renders and edit-from-cart sets its inputs: follow both
        t.addEventListener("change", d),
        window.MutationObserver &&
          new MutationObserver(function () {
            clearTimeout(D.__t), (D.__t = setTimeout(d, 60));
          }).observe(t, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["value"] }),
        d(),
        i(".g3-num", e).forEach(function (t, e) {
          t.textContent = e + 1;
        });
    }
  }
  // Delivery tab: the live Page "product-delivery-tab-content" without its "Same-Day Delivery"
  // banner image (and the link/box around it). The page itself isn't changed.
  function DV(t) {
    var e = document.createElement("div");
    return (
      (e.innerHTML = t || "<p>Choose your delivery date in the cart.</p>"),
      i("img", e).forEach(function (t) {
        for (var n = t; n.parentNode && n.parentNode !== e && 1 === n.parentNode.children.length; ) n = n.parentNode;
        n.remove();
      }),
      e.innerHTML
    );
  }
  function s0(t) {
    return o(String(null == t ? "" : t));
  }
  // Photos kept from the cart line while editing (gl-v3-edit.js), in property order.
  function K() {
    return i(".g3e-keep input")
      .map(function (t) {
        return t.value;
      })
      .filter(function (t) {
        return /^https?:\/\/\S+/.test(t);
      });
  }
  function g(t) {
    if (t && !t.__fa) {
      if (((t.__fa = !0), !n("#g3fa-css"))) {
        var e = a(
          "style",
          "",
          '.g3fa{position:relative}.g3fa:before,.g3fa:after{content:"";position:absolute;top:0;bottom:0;width:56px;pointer-events:none;z-index:1;transition:opacity .2s}.g3fa:after{right:0;background:linear-gradient(90deg,rgba(255,255,255,0),#fff 80%)}.g3fa:before{left:0;background:linear-gradient(270deg,rgba(255,255,255,0),#fff 80%);opacity:0}.g3fa--s:before{opacity:1}.g3fa--e:after,.g3fa--n:after{opacity:0}.g3fa-b{position:absolute;top:50%;transform:translateY(-50%);width:34px;height:34px;border-radius:50%!important;background:#fff!important;border:0!important;box-shadow:0 2px 10px rgba(0,0,0,.2);color:#1F1A17!important;display:flex;align-items:center;justify-content:center;z-index:2;padding:0!important;cursor:pointer}.g3fa-r{right:4px}.g3fa-l{left:4px;display:none}.g3fa--s .g3fa-l{display:flex}.g3fa--e .g3fa-r,.g3fa--n .g3fa-r{display:none}.g3-rr .g3fa-b{top:calc(var(--g3fa-h,50%) / 2)}@media(max-width:989px){.g3cd .g3fa{margin-right:-16px}.g3cd .g3fa .g3cd-strip{margin-right:0}}.g3-box.g3-rr{border:0;padding:0;border-radius:0}.g3-rr .g3-tiles{display:flex;gap:14px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;padding-bottom:2px}.g3-rr .g3-tiles::-webkit-scrollbar{display:none}.g3-rr .g3-tile{flex:none;width:calc((100% - 42px) / 4);border:0;border-radius:0;overflow:visible;scroll-snap-align:start}.g3-rr .g3-tile div{border-radius:14px;overflow:hidden}.g3-rr .g3-tile p{padding:9px 0 0}.g3-rr .g3-tile b{padding:3px 0 0}@media(max-width:989px){.g3-rr .g3-tile{width:42%}}',
        );
        (e.id = "g3fa-css"), document.head.appendChild(e);
      }
      var i = function (t) {
          return (
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="' +
            t +
            '"/></svg>'
          );
        },
        o = a("div", "g3fa");
      t.parentNode.insertBefore(o, t), o.appendChild(t);
      var r = a("button", "g3fa-b g3fa-l", i("M15 6l-6 6 6 6")),
        l = a("button", "g3fa-b g3fa-r", i("M9 6l6 6-6 6"));
      (r.type = l.type = "button"),
        r.setAttribute("aria-label", "Scroll back"),
        l.setAttribute("aria-label", "See more"),
        o.appendChild(r),
        o.appendChild(l);
      var d = function () {
          var e = t.scrollWidth - t.clientWidth;
          o.classList.toggle("g3fa--n", e <= 4),
            o.classList.toggle("g3fa--s", t.scrollLeft > 4),
            o.classList.toggle("g3fa--e", e > 4 && t.scrollLeft >= e - 4);
          var i = n(".g3-tile div", t);
          i && o.style.setProperty("--g3fa-h", i.offsetHeight + "px");
        },
        c = function (e) {
          t.scrollBy({
            left: e * Math.max(120, 0.8 * t.clientWidth),
            behavior: "smooth",
          });
        };
      (r.onclick = function () {
        c(-1);
      }),
        (l.onclick = function () {
          c(1), s("row_more", { row: t.className });
        }),
        t.addEventListener("scroll", d, { passive: !0 }),
        window.addEventListener("resize", d),
        d(),
        setTimeout(d, 600),
        setTimeout(d, 2e3);
    }
  }
  function u(t, e, r) {
    if (!n("#g3xr-css")) {
      var s = a(
        "style",
        "",
        ".g3-xr.g3-xrr{flex-direction:column;align-items:stretch;gap:8px;padding:12px 14px}.g3-xqs{display:grid}.g3-xq{grid-area:1/1;display:flex;flex-direction:column;gap:4px;opacity:0;transition:opacity .4s;pointer-events:none}.g3-xq.on{opacity:1;pointer-events:auto}.g3-xq p{margin:0;font-size:14.5px;line-height:1.4;color:#1F1A17}.g3-xq b{font-size:12.5px;color:#6B625C;font-weight:600}.g3-xm{display:flex;gap:6px;align-items:center;flex-wrap:wrap;font-size:12px;color:#6B625C;border-top:1px solid rgba(138,90,0,.15);padding-top:8px}.g3-xm .g3-stars{display:none}.g3-xm .g3-lnk{font-size:12px}.g3-rvq{flex-basis:100%;border-top:1px solid #F1E6CF;padding-top:16px}.g3-rvq .g3-xq p{font-size:17px;line-height:1.45}.g3-rvq .g3-xq b{font-size:13.5px}",
      );
      (s.id = "g3xr-css"), document.head.appendChild(s);
    }
    var l = Math.floor(Math.random() * e.length),
      d = a(
        "div",
        "g3-xqs" + (r ? " " + r : ""),
        e
          .map(function (t, e) {
            return (
              '<div class="g3-xq' +
              (e === l ? " on" : "") +
              '"><p>&ldquo;' +
              o(t[0]) +
              "&rdquo;</p><b>" +
              o(t[1]) +
              "</b></div>"
            );
          })
          .join(""),
      ),
      c = i(".g3-xq", d),
      p = !1;
    return (
      t.addEventListener("mouseenter", function () {
        p = !0;
      }),
      t.addEventListener("mouseleave", function () {
        p = !1;
      }),
      setInterval(function () {
        p ||
          document.hidden ||
          (c[l].classList.remove("on"),
          (l = (l + 1) % c.length),
          c[l].classList.add("on"));
      }, 6e3),
      d
    );
  }
  // ---- Photo slots (approved "photo slots" style), shared by every gl-v3 photo step ----
  // One group per UploadKit uploader in the step: personalised 1-3 slots ("up to N" in the old
  // box), burn cakes Top + Bottom (1 each, both required), butterfly boxes 4 (optional, opt-in).
  // UploadKit's own UI stays in the page off-screen; a slot opens its uploader. Each slot shows
  // that uploader's thumbnail, or the photo kept from the cart line while editing.
  function UN(t) {
    // property/field name -> uploader field: "properties[_Burn Cake Top Field 2]" -> "burn cake top field"
    return String(t)
      .replace(/^properties\[/, "")
      .replace(/\]$/, "")
      .replace(/^_/, "")
      .replace(/ \d+$/, "")
      .trim()
      .toLowerCase();
  }
  // UploadKit's own settings for a field (count, crop, print shape), read from window.UploadKit.
  // An uploader with an overlay prints round (UploadKit's overlays are circle masks).
  function UC(nm) {
    var t = (UC.c = UC.c || {});
    if (!(nm in t)) {
      var e = null,
        n = [];
      try {
        (function a(t, i) {
          if (!e && t && "object" == typeof t && i < 7 && n.indexOf(t) < 0)
            if ((n.push(t), Array.isArray(t)))
              t.forEach(function (t) {
                a(t, i + 1);
              });
            else if (t.id && t.name && "cropSetting" in t) UN(t.name) === nm && (e = t);
            else
              for (var r in t) {
                var o = t[r];
                o && "object" == typeof o && a(o, i + 1);
              }
        })(window.UploadKit, 0);
      } catch (t) {}
      if (!e) return null;
      t[nm] = { max: e.multiple ? +e.multipleMax || 1 : 1, crop: e.cropSetting || "", round: !!(e.enableOverlay && e.overlays && e.overlays.length) };
    }
    return t[nm];
  }
  function SLB(l) {
    if (!n("#g3sl-css")) {
      var t = a(
        "style",
        "",
        '.g3-up .gl-upload-box{background:none!important;border:0!important;padding:0!important;text-align:left!important;box-shadow:none!important}.g3-up .gl-upload-box__title,.g3-up .gl-upload-box__drag,.g3-up--sl .g3e-ph{display:none!important}.g3-up .uploadkit-uploader.g3-uk-off{position:absolute!important;left:-9999px!important;top:auto!important;width:1px!important;height:1px!important;overflow:hidden!important}.g3-slw{display:flex;flex-direction:column;gap:14px;margin:0 0 10px}.g3-slw[hidden]{display:none}.g3-slgl{font-size:14px;font-weight:600;margin:0 0 6px;color:#1F1A17}.g3-slots{display:flex;gap:10px}.g3-slot{flex:1;max-width:120px;aspect-ratio:1;border:1.5px dashed #CFC6BE;border-radius:12px!important;background:#fff center/cover no-repeat;min-width:0;height:auto!important;text-transform:none!important;letter-spacing:0!important;line-height:1.2!important;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;font:inherit;font-size:12.5px;color:#6B625C;cursor:pointer;padding:0;position:relative;transition:border-color .15s}.g3-slot:hover{border-color:#1F1A17}.g3-slot b{font-size:26px;font-weight:400;line-height:1}.g3-slot--1{border-style:solid;border-color:#1F1A17;color:#1F1A17;font-weight:600}.g3-slot--on{border:0}.g3-slot--on b,.g3-slot--on span{display:none}.g3-slot--on:after{content:"Change";position:absolute;left:6px;bottom:6px;background:rgba(31,26,23,.75);color:#fff;font-size:11px;font-weight:600;border-radius:6px;padding:2px 6px}.g3-slg--need .g3-slot--1,.g3-slg--need .g3-slot:not(.g3-slot--on){border-color:#C4264F;color:#C4264F}.g3-slg--need .g3-slgl{color:#C4264F}.g3-up .gl-upload-box__note,.g3-up .gl-upload-box__help{font-size:12.5px!important;color:#6B625C!important;text-align:left!important;margin:0 0 2px!important;line-height:1.45}.g3-up .gl-upload-box__contact{color:#1F1A17!important;font-weight:600}.g3-po{margin:0 0 12px}.g3-slots .g3-slot--round{border-radius:50%!important}.g3-slot--round.g3-slot--on:after{left:50%;bottom:10px;transform:translateX(-50%)}.g3-pbv{margin:4px 0 0;max-width:300px}.g3-pbv svg{display:block;width:100%;height:auto;border-radius:14px}.g3-slgh{display:block;font-size:12.5px;font-weight:400;color:#6B625C;margin-top:1px}.g3-slw--burn{flex-direction:row;align-items:flex-start;gap:8px}.g3-slw--burn .g3-slg{flex:1;min-width:0}.g3-slw--burn .g3-slot{max-width:none;width:100%}.g3-slar{flex:none;align-self:center;margin-top:34px;font-size:22px;color:#8A5A00}',
      );
      (t.id = "g3sl-css"), document.head.appendChild(t);
    }
    var e = n(".g3-slw", l);
    e ||
      ((e = a("div", "g3-slw")),
      l.insertBefore(e, (n(".g3-po", l) || n(".g3-upo", l) || n(".g3-upn", l) || n(".g3-sh", l)).nextSibling));
    var o = i(".gl-upload-box__title", l)
        .map(function (t) {
          return (t.textContent.match(/up to (\d+)/i) || [])[1];
        })
        .filter(Boolean)[0],
      r = {};
    i(".g3-slg", e).forEach(function (t) {
      r[t.__nm] = 1;
    });
    // field names: the uploaders in this step; burn cakes always get Top and Bottom (the
    // burn template's own script can delete an uploader before this step takes it over)
    var d0 = [];
    i(".uploadkit-uploader", l).forEach(function (t) {
      t.classList.add("g3-uk-off");
      var e = UN((n(".uploadkit-button", t) || { getAttribute: function () {} }).getAttribute("data-uploader-name") || "");
      e && !/postcard/.test(e) && d0.indexOf(e) < 0 && d0.push(e);
    }),
      d0.some(function (t) {
        return /top|bottom/.test(t);
      }) &&
        UF(l).forEach(function (t) {
          var e = UN(n(".uploadkit-button", t).getAttribute("data-uploader-name") || "");
          /top|bottom/.test(e) && d0.indexOf(e) < 0 && d0.push(e);
        }),
      d0.sort(function (t, e) {
        return /top/.test(e) - /top/.test(t);
      }),
      l.__bf && (d0 = d0.slice(0, 1)),
      d0.forEach(function (a) {
        if (!r[a]) {
          r[a] = 1;
          var u0 = UC(a),
            c = l.__bf ? 4 : /top|bottom/.test(a) ? 1 : Math.min((u0 && u0.max) || +o || 1, 4);
          // personalised: heading + line follow what the uploader allows (Phillip, 27 Oct)
          if (!l.__bf && !/top|bottom/.test(a)) {
            var b0 = /brownie/i.test(((window.GLV2 || {}).p3 || {}).title || ""),
              q0 = u0 && "1:1" === u0.crop;
            (n(".g3-sh h2", l).textContent = 1 === c && b0 ? "Upload Photo" : "Upload Photo/Logo"),
              (n(".g3-upo", l).textContent =
                1 === c
                  ? b0
                    ? "Add 1 " + (q0 ? "square " : "") + "photo."
                    : "Add 1 photo or logo."
                  : "Add 1 to " + c + " photos or logos."),
              b0 && (l.__pb = 1);
          }
          // local label (an undeclared "d" here overwrote the store review quotes and emptied "What customers say")
          var lb = /top/.test(a) ? "Top photo" : /bottom/.test(a) ? "Bottom photo" : "";
          e.appendChild(SL(a, c, lb, !l.__bf, l, u0 && u0.round));
        }
      }),
      // burn: Top -> Bottom, side by side
      n(".g3-slg + .g3-slg", e) &&
        /top|bottom/.test(i(".g3-slg", e)[0].__nm) &&
        !n(".g3-slar", e) &&
        (e.classList.add("g3-slw--burn"),
        // play the sample only while it's on screen; both squares share one clock
        "IntersectionObserver" in window &&
          new IntersectionObserver(function (t) {
            var on = t[0].isIntersecting && !(window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches);
            n(".g3-bdemo video", e) &&
              i(".g3-bdemo video", e).forEach(function (v) {
                on ? ((v.muted = !0), (v.play() || { catch: function () {} }).catch(function () {})) : v.pause();
              });
          }).observe(e),
        e.insertBefore(a("span", "g3-slar", "&rarr;"), i(".g3-slg", e)[1]),
        n(".g3-slar", e).setAttribute("aria-hidden", "true")),
      e.children.length && l.classList.add("g3-up--sl"),
      l.__bf && PS(l);
  }
  // the form's UploadKit uploaders (not the postcard step's)
  function UF(l) {
    var t = n("form.gl-atc-container");
    return i(".uploadkit-uploader", l)
      .concat(t ? i(".uploadkit-uploader", t) : [])
      .filter(function (t) {
        return !t.closest("#postCardStep") && n(".uploadkit-button", t);
      });
  }
  function SL(nm, cnt, lab, req, stp, rnd) {
    // the uploader for this field, looked up each time (prefer the one in the step)
    var U = function () {
        return (
          UF(stp).filter(function (t) {
            return UN(n(".uploadkit-button", t).getAttribute("data-uploader-name") || "") === nm;
          })[0] || null
        );
      },
      r = a(
        "div",
        "g3-slg g3-sl",
        (lab
          ? '<div class="g3-slgl">' +
            o0(lab) +
            (/top/.test(nm) ? '<span class="g3-slgh">Seen first</span>' : /bottom/.test(nm) ? '<span class="g3-slgh">Revealed after the burn</span>' : "") +
            "</div>"
          : "") + '<div class="g3-slots"></div>',
      ),
      l = n(".g3-slots", r),
      d = [];
    (r.__nm = nm), (r.__req = req), Object.defineProperty(r, "__u", { get: U });
    for (var c = 0; c < cnt; c++) {
      var p = a(
        "button",
        // the slot takes the print's shape: round for cake/cupcake/cookie discs, square otherwise
        // (burn squares stay square for their sample footage)
        "g3-slot" + (c ? "" : " g3-slot--1") + (rnd && !/top|bottom/.test(nm) ? " g3-slot--round" : ""),
        "<b>+</b><span>" +
          (c ? (req ? "Optional" : "Add photo") : cnt > 1 ? "Add photo" : lab || (stp && stp.__pb) ? "Add photo" : "Add photo or logo") +
          "</span>",
      );
      // burn cakes: an empty slot plays a short sample of the burn (top burns away, bottom is revealed)
      /top|bottom/.test(nm) && p.insertBefore(BD(/top/.test(nm)), p.firstChild),
        (p.type = "button"),
        p.setAttribute("aria-label", (lab ? lab + ": " : "") + (c ? "add another photo" : "add your photo")),
        p.addEventListener("click", function () {
          var t = U();
          s("pdp_upload_slot"), r.classList.remove("g3-slg--need"), t && n(".uploadkit-button", t).click();
        }),
        l.appendChild(p),
        d.push(p);
    }
    // photos in this group: uploaded (UploadKit inputs) or kept from the cart line
    r.__has = function () {
      var t = U();
      return (
        (t &&
          i(".uploadkit-attribute-container input", t).some(function (t) {
            return t.value && !t.disabled;
          })) ||
        i(".g3e-keep input").some(function (t) {
          return !t.disabled && UN(t.name) === nm && /^https?:\/\//.test(t.value);
        })
      );
    };
    var v = function () {
      var u = U(),
        o = u && n(".uploadkit-thumbnails", u),
        t = o
          ? i("img", o)
              .map(function (t) {
                return t.currentSrc || t.src;
              })
              .filter(Boolean)
          : [],
        e = i(".g3e-keep input")
          .filter(function (t) {
            return UN(t.name) === nm && /^https?:\/\//.test(t.value);
          })
          .map(function (t) {
            return TH(t.value);
          });
      d.forEach(function (n, i) {
        var a = t[i] || (t.length ? "" : e[i]);
        n.classList.toggle("g3-slot--on", !!a), (n.style.backgroundImage = a ? 'url("' + a.replace(/"/g, "%22") + '")' : "");
      }),
        // photo brownies: the photo on the brownie, under the slot
        stp &&
          stp.__pb &&
          (function () {
            var e = n(".g3-pbv", stp);
            e || ((e = a("div", "g3-txv g3-pbv")), e.setAttribute("aria-hidden", "true"), n(".g3-slw", stp).appendChild(e));
            var i = d.map(function (t) {
              return (t.style.backgroundImage.match(/url\("?(.*?)"?\)$/) || [])[1];
            })[0];
            e.__p !== (i || "-") && ((e.__p = i || "-"), (e.innerHTML = BV("", e.__p)));
          })(),
        r.__has() && r.classList.remove("g3-slg--need"),
        stp && !i(".g3-slg--need", stp).length && stp.classList.remove("g3-up--need"),
        // butterfly: photos kept by edit-from-cart arrive later and switch the step on
        stp && stp.__bf && PS(stp);
    };
    return (
      (r.__v = v),
      // repaint when the uploader (wherever it is in the form) changes
      window.MutationObserver &&
        new MutationObserver(v).observe(n("form.gl-atc-container") || stp, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["src", "value"] }),
      window.MutationObserver &&
        new MutationObserver(v).observe(stp, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["src", "value"] }),
      v(),
      r
    );
  }
  // Burn sample: the product's own footage (a lighter at the centre of the top print, the hole
  // opens to the second print). Top square loops the burn, bottom square the reveal. Each is a
  // tiny muted WebM/MP4 cut from that product's own GIF (birthday, pink, blue, white, gender reveal, Valentine's); the poster is
  // the first/last frame, which is all reduced-motion users see. Nothing downloads until the
  // squares are on screen; hidden as soon as the slot has a photo.
  function BD(top) {
    if (!n("#g3bd-css")) {
      var t = a(
        "style",
        "",
        ".g3-slot{overflow:hidden}.g3-slot>b,.g3-slot>span:not(.g3-bdemo){position:relative;z-index:2}.g3-bdemo{position:absolute;inset:0;pointer-events:none;border-radius:inherit;overflow:hidden;z-index:0;background:#6CCFF0}.g3-bdemo video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover}.g3-slot:not(.g3-slot--on):has(.g3-bdemo){justify-content:flex-end;padding-bottom:8px}.g3-slot:not(.g3-slot--on)>.g3-bdemo~b{display:none}.g3-slot:not(.g3-slot--on)>.g3-bdemo~span{background:rgba(255,255,255,.94);border-radius:999px;padding:3px 10px;line-height:1.3!important;box-shadow:0 1px 3px rgba(0,0,0,.15)}.g3-slot:not(.g3-slot--on)>.g3-bdemo~span:before{content:'+ '}.g3-slot--on .g3-bdemo{display:none}",
      );
      (t.id = "g3bd-css"), document.head.appendChild(t);
    }
    var h = ((window.GLV2 || {}).p3 || {}).handle || "",
      f = "gl-burn-" + (/pink/.test(h) ? "pink" : /blue/.test(h) ? "blue" : /white/.test(h) ? "white" : /gender/.test(h) ? "gender" : /valentine/.test(h) ? "val" : "gold") + "-" + (top ? "top" : "bottom"),
      u = function (x) {
        return String((window.GLV2 || {}).editJs || "").replace(/gl-v3-edit\.js.*$/, x);
      },
      e = a("span", "g3-bdemo");
    return (
      e.setAttribute("aria-hidden", "true"),
      (e.innerHTML =
        '<video muted playsinline loop preload="none" poster="' + u(f + ".jpg") + '"><source src="' + u(f + ".mp4") + '" type="video/mp4"><source src="' + u(f + ".webm") + '" type="video/webm"></video>'),
      e
    );
  }
  // Butterfly: "No photos" / "Add 4 photos +$20". Off disables the photo fields, so neither the
  // photos nor the hidden $20 line are sent.
  function PO(l) {
    var t = a(
      "div",
      "g3-seg g3-po",
      '<button type="button" data-p="0">No photos</button><button type="button" data-p="1">Add 4 photos +$20</button>',
    );
    t.setAttribute("role", "radiogroup"),
      t.setAttribute("aria-label", "Photos"),
      l.insertBefore(t, (n(".g3-upo", l) || n(".g3-sh", l)).nextSibling),
      i("button", t).forEach(function (t) {
        t.onclick = function () {
          (l.__on = "1" === t.getAttribute("data-p")), (l.__set = !0), s("pdp_photos_optin", { on: l.__on }), PS(l), window.GL3 && GL3.sync && GL3.sync();
        };
      });
  }
  function PS(l) {
    var t = n(".g3-slw", l),
      e = i(".g3-slg", l);
    // editing a line that has photos (or photos already uploaded): start opted in
    l.__set ||
      (l.__on = e.some(function (t) {
        return t.__has();
      })),
      t && (t.hidden = !l.__on),
      i(".g3-po button", l).forEach(function (t) {
        t.classList.toggle("on", ("1" === t.getAttribute("data-p")) === !!l.__on);
      }),
      e.forEach(function (t) {
        (t.__u ? i(".uploadkit-attribute-container input", t.__u) : [])
          .concat(
            i(".g3e-keep input").filter(function (e) {
              return UN(e.name) === t.__nm;
            }),
          )
          .forEach(function (t) {
            t.disabled = !l.__on;
          });
      });
  }
  function o0(t) {
    return o(String(t));
  }
  function h() {
    i(".g3-buy .g3-sh h2, .g3-buy .g3-x2 h2").forEach(function (t) {
      if (!t.children.length) {
        var e = t.textContent.replace(/\S+/g, function (t, e) {
          return e && c.test(t)
            ? t.toLowerCase()
            : t.charAt(0).toUpperCase() + t.slice(1);
        });
        e !== t.textContent && (t.textContent = e);
      }
    });
  }
})();

/* Featured occasion link (Theme settings > Featured occasion collections, data in gl-v2.liquid):
   "More Halloween →" under the price, with the photo of the first other gift. One other gift: a straight
   link to it. Two or more: a panel (bottom sheet on phones, side drawer on desktop) with their tiles and
   "Shop all". Same events as "You might also like", as list "c.<collection id>"; the next add of a gift
   opened from here carries _gl_reco "pos:c.<id>" (GL3Add reads sessionStorage glReco). */
!(function () {
  var G = window.GLV2 || {},
    F = (G.product || {}).featured,
    me = G.p3 || {};
  if (!F || !F.items || !F.items.length) return;
  var lid = "c." + F.id,
    items = F.items,
    one = items.length === 1,
    esc = function (t) {
      return String(null == t ? "" : t).replace(/[&<>"]/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
      });
    },
    money = function (c) {
      return window.GL2 && GL2.money ? GL2.money(c) : "$" + (c / 100).toFixed(0);
    },
    pub = function (n, d) {
      window.GLA && GLA.pub ? GLA.pub(n, d) : window.Shopify && Shopify.analytics && Shopify.analytics.publish(n, d);
    },
    pick = function (x, i) {
      (window.GLA && GLA.pubNav ? GLA.pubNav : pub)("gl_reco_click", { source_product_id: me.id, product_id: x.id, position: i + 1, list_id: lid });
      try {
        sessionStorage.setItem("glReco", JSON.stringify({ h: x.h, pos: i + 1, list: lid, t: Date.now() }));
      } catch (e) {}
    },
    tries = 0,
    mount = function () {
      var pr = document.querySelector(".g3 .g3-pr");
      if (!pr) return void (++tries < 40 && setTimeout(mount, 250));
      if (document.querySelector(".g3fo")) return;
      var a = document.createElement("a"),
        f = items[0];
      a.className = "g3fo";
      a.style.setProperty("--fo", F.c || "#f4c95d");
      a.href = one ? f.u : F.u;
      one || a.setAttribute("aria-haspopup", "dialog");
      a.innerHTML =
        (f.i ? '<img src="' + esc(f.i.replace(/width=\d+/, "width=60")) + '" alt="" width="22" height="22">' : "") +
        "<span>More " + esc(F.t) + '</span><span aria-hidden="true">&rarr;</span>';
      pr.parentNode.insertBefore(a, pr.nextSibling);
      a.addEventListener("click", function (e) {
        if (one) return pick(f, 0);
        e.preventDefault();
        open(a);
      });
    },
    sheet = null,
    seen = !1,
    open = function (from) {
      if (!sheet) {
        sheet = document.createElement("div");
        sheet.className = "g3fo-wrap";
        sheet.innerHTML =
          '<div class="g3fo-dim"></div><div class="g3 g3fo-p" role="dialog" aria-modal="true" aria-labelledby="g3fo-h">' +
          '<div class="g3fo-hd"><h2 id="g3fo-h">More ' + esc(F.t) + '</h2><button type="button" class="g3fo-x" aria-label="Close">&times;</button></div>' +
          '<div class="g3-tiles g3fo-tiles">' +
          items
            .map(function (t, i) {
              return (
                '<a class="g3-tile" href="' + esc(t.u) + '" data-i="' + i + '"><div>' +
                (t.i ? '<img loading="lazy" src="' + esc(t.i) + '" alt="">' : "") +
                "</div><p>" + esc(t.t) + "</p>" +
                (+t.n > 0 && t.r
                  ? '<span class="g3-tst" aria-label="Rated ' + esc((+t.r).toFixed(1)) + " out of 5 from " + esc(t.n) +
                    ' reviews"><span class="g3-tst-s" aria-hidden="true">&#9733;</span> ' + esc((+t.r).toFixed(1)) +
                    ' <span class="g3-mut">(' + esc(t.n) + ")</span></span>"
                  : "") +
                "<b>" + money(t.p) + "</b></a>"
              );
            })
            .join("") +
          '</div><a class="g3fo-all" href="' + esc(F.u) + '">Shop all ' + esc(F.t) + " &rarr;</a></div>";
        document.body.appendChild(sheet);
        sheet.querySelector(".g3fo-dim").onclick = close;
        sheet.querySelector(".g3fo-x").onclick = close;
        sheet.querySelector(".g3fo-tiles").addEventListener("click", function (e) {
          var t = e.target.closest(".g3-tile");
          t && pick(items[+t.getAttribute("data-i")], +t.getAttribute("data-i"));
        });
        sheet.addEventListener("keydown", function (e) {
          if (e.key === "Escape") return close();
          if (e.key !== "Tab") return;
          // focus stays in the panel
          var f = [].slice.call(sheet.querySelectorAll(".g3fo-p a, .g3fo-p button")),
            first = f[0],
            last = f[f.length - 1];
          e.shiftKey && document.activeElement === first ? (e.preventDefault(), last.focus()) : !e.shiftKey && document.activeElement === last && (e.preventDefault(), first.focus());
        });
      }
      sheet.__from = from;
      document.documentElement.classList.add("g3fo-on");
      requestAnimationFrame(function () {
        document.documentElement.classList.add("g3fo-open");
      });
      sheet.querySelector(".g3fo-x").focus({ preventScroll: !0 });
      seen ||
        ((seen = !0),
        pub("gl_reco_view", { source_product_id: me.id, shown_product_ids: items.slice(0, 12).map(function (t) { return t.id; }), list_id: lid }));
    },
    close = function () {
      var h = document.documentElement;
      h.classList.remove("g3fo-open");
      setTimeout(function () {
        h.classList.remove("g3fo-on");
      }, 250);
      sheet && sheet.__from && sheet.__from.focus({ preventScroll: !0 });
    };
  "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", mount) : mount();
})();
